import axios from "axios";
import { backend_url } from "@/constants";
import { getJobResult, pollJob } from "@api/jobApi";
import type { BulkClientUploadResponse } from "@/pages/TaxProClientList/components/BulkClientModal/types";
import { Endpoints } from "./endpoints";

/**
 * Uploads CSV file to perform bulk client upload.
 * @param file CSV file containing client records to upload to business.
 */
export const bulkUpload = async (
  file: File
): Promise<BulkClientUploadResponse> => {
  if (!file) {
    return Promise.reject(new Error("No file provided for upload."));
  }

  // Prepare FormData
  const formData = new FormData();
  formData.append("files", file);

  // Submit Bulk Upload Job
  const bulkUploadResponse = await axios.post(
    `${backend_url}/${Endpoints.bulkUpload}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
    }
  );

  if (bulkUploadResponse.status !== 200) {
    return Promise.reject(
      new Error("An unexpected error occurred during the upload.")
    );
  }

  // Poll Job until completion
  const jobId = bulkUploadResponse.data.content.id;
  const status = await pollJob(jobId);

  if (status === "failed") {
    return Promise.reject(new Error(`Job failed with ID: ${jobId}`));
  }

  // Retrieve Job Results
  return getJobResult(jobId);
};
